import { useEffect, useState } from "react";
import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";
import { useQuery } from "react-query";

const RoundTimer = (props) => {
  const [roundMinutes, setRoundMinutes] = useState(props.roundminute);
  const [roundSeconds, setRoundSeconds] = useState(props.roundsecond);
  const [roundEfState, setRoundEfState] = useState(false);
  const [btnRoundStart, setBtnRoundStart] = useState("");
  const [btnRoundPause, setBtnRoundPause] = useState("dontshow");
  const [btnRoundStop, setBtnRoundStop] = useState("dontshow");

  useEffect(() => {
    if (roundSeconds > -1) {
      setTimeout(() => roundCountDown(), 1000);
    } else {
      setRoundSeconds(59);
    }
  });

  const roundCountDown = () => {
    if (roundEfState) {
      roundMinutes === 0 && roundSeconds === 0
        ? setRoundSeconds(0)
        : setRoundSeconds(roundSeconds - 1);
      if (roundSeconds === 0) {
        roundMinutes > 0
          ? setRoundMinutes(roundMinutes - 1)
          : setRoundMinutes(0);
      }
    }
  };

  const localPlaycode = localStorage.getItem("playcode");
  const { status1, data1, error1, isFetching1 } = useQuery(
    "todos2",
    async () => {
      const { data2 } = await axiosConfig.get(
        "send-round-timer.php?playcode=" +
          localPlaycode +
          "&round_minute=" +
          roundMinutes +
          "&round_second=" +
          roundSeconds
      );
      return data2;
    },
    {
      refetchInterval: 1000,
      //   enabled: queryRun,
    }
  );

  function setPlayStstus(playStatus) {
    try {
      axiosConfig
        .get(
          "set-play-timer-status.php?playcode=" +
            localPlaycode +
            "&play_status=" +
            playStatus
        )
        .then((response) => {
          console.log("set playStatus");
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  const StartRoundTimer = () => {
    setRoundEfState(true);
    setBtnRoundStart("dontshow");
    setBtnRoundStop("dontshow");
    setBtnRoundPause("");
  };
  const PauseRoundTimer = () => {
    setRoundEfState(false);
    setBtnRoundStart("");
    setBtnRoundStop("");
    setBtnRoundPause("dontshow");
  };
  const StopRoundTimer = () => {
    setRoundEfState(false);
    setRoundSeconds(0);
    setRoundMinutes(1);
    setBtnRoundPause("dontshow");
    setBtnRoundStart("");
    setBtnRoundStop("dontshow");
    setPlayStstus("play");
  };

  return (
    <>
      <div className="row timerBox mt-4">
        <div className="col-md-12 col-12">
          <h6 className="full-width" style={{ textAlign: "center" }}>
            وقت استراحت
          </h6>
        </div>
        <div className="col-md-8 col-8 btncoridor">
          <button
            className={
              "btn btn-sm btn-success btn-lg col-md-3 " + btnRoundStart
            }
            onClick={StartRoundTimer}
          >
            شروع
          </button>
          <button
            className={
              "btn btn-sm btn-warning btn-lg col-md-3 " + btnRoundPause
            }
            onClick={PauseRoundTimer}
          >
            وقفه
          </button>{" "}
          &nbsp; &nbsp;
          <button
            className={
              "btn btn-sm btn-danger btn-lg col-md-3 mr-3 " + btnRoundStop
            }
            onClick={StopRoundTimer}
          >
            پایان
          </button>
        </div>
        <div
          className="col-md-4 col-4"
          style={{ textAlign: "center", fontSize: "36px" }}
        >
          <p className="IRANSansBold" style={{ direction: "ltr" }}>
            {numberToPersian(roundMinutes)} : {numberToPersian(roundSeconds)}
          </p>
        </div>
      </div>
    </>
  );
};

export default RoundTimer;
